





















































import { Vue, Component, Mixins, Prop } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import InviteMerchantSignupModalsModel from '@/views/Models/InviteMerchantSignupModalsModel.vue';
import FormOffer from '@/views/Offers/OfferCreation/Steps/FormOffer/FormOffer.vue';
import TrashIcon from '@/components/icons/Trash.vue';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';

import { IOfferEdit } from '@/models/offer';
import { ILocation } from '@/models/location';

import eventBus from '@/utils/eventBus';

@Component({
  components: {
    FilledButton,
    Typography,
    CloseModalIcon,
    FormOffer,
    TrashIcon
  }
})
export default class EditOffer extends Mixins(
  Vue,
  InviteMerchantSignupModalsModel
) {
  @Prop() readonly code!: string;
  @Prop() offer!: IOfferEdit;
  @Prop() locations!: ILocation[];
  @Prop() businessId!: string;
  @Prop() readonly onSuccess?: () => void;

  submitLoading = false;

  async handleSubmit() {
    eventBus.$emit('saveOffer');
  }

  async onSubmit(formattedPayload: any) {
    this.submitLoading = true;

    const { status, data = {} } = await this.service.updateOffer(
      this.code,
      this.offer.id,
      {
        ...formattedPayload,
        business: this.businessId,
        id: this.offer.id,
        discountTagValue: formattedPayload.discount
          ? formattedPayload.discount.value
          : ''
      }
    );

    if (this.onSuccess) this.onSuccess();

    this.submitLoading = false;
    this.onClose();
  }

  openDeleteConfirmation() {
    eventBus.$emit('closeModal');

    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        icon: 'none',
        hideCancelButton: true,
        confirmEvent: '',
        mobileFullScreen: false,
        componentToRender: 'confirmationDeleteOffer'
      }),
      {
        offer: this.offer,
        code: this.code
      }
    );

    return;
  }
}
